import { CONTACT_TOPICS } from './catalogs'

type ContactLike = { name?: { value?: string }; role?: { value?: string }; topics?: string[]; locationIds?: string[] }

const TOPIC_LABEL: Record<string, string> = Object.fromEntries(CONTACT_TOPICS.map((t) => [t.id, t.label]))

/** What a contact's tags say it's for: "Private events & Reservations". */
export function contactPurpose(c: ContactLike): string {
  const labels = (c.topics ?? []).map((t) => TOPIC_LABEL[t] ?? t)
  return labels.length <= 2 ? labels.join(' & ') : `${labels.slice(0, -1).join(', ')} & ${labels[labels.length - 1]}`
}

/**
 * How a contact is named everywhere: the person ("Hunter Reynolds, General manager") when someone
 * picks up, otherwise what the line is for ("Private events & Reservations").
 */
export function contactLabel(c: ContactLike): string {
  const name = c.name?.value?.trim()
  const role = c.role?.value?.trim()
  if (name) return role ? `${name}, ${role}` : name
  return contactPurpose(c) || 'New contact'
}

/** Whether a contact applies at a location: no locations ticked means every location. */
export function contactCovers(c: ContactLike, locationId: string): boolean {
  return !c.locationIds?.length || c.locationIds.includes(locationId)
}
